import ReactDOM from 'react-dom';
import AccountRecoveryPage from '../components/account-recovery/AccountRecoveryPage';
import { initializeI18n } from '../localization/i18n';

window.renderAccountRecovery = (elementId, props) => {
    const root = document.getElementById(elementId);
    if (!root) return;
    initializeI18n().then(() => {
        ReactDOM.render(<AccountRecoveryPage {...props} />, root);
    }).catch(console.error);
};